import { ThemeProps as Prop, StaticProfiles } from '@powdr/constants';

export const StaticTheme = {
  [StaticProfiles.COLORS]: {
    [Prop.BLACK]: '#000000',
    [Prop.WHITE]: '#FFFFFF',
  },
  [StaticProfiles.SHADES]: {
    [Prop.LIGHTEST]: '#F0F0F0',
    [Prop.LIGHTER]: '#E0E0E0',
    [Prop.LIGHT]: '#CCCCCC',
    [Prop.GRAY]: '#8B8B8B',
    [Prop.GRAYER]: '#696969',
    [Prop.GRAYEST]: '#525257',
    [Prop.DARK]: '#333333',
    [Prop.DARKER]: '#222222',
    [Prop.DARKEST]: '#292929',
  },
  [StaticProfiles.DIFFICULTY]: {
    [Prop.BEGINNER]: '#73C053',
    [Prop.INTERMEDIATE]: '#30A8E0',
    [Prop.EXPERT]: '#000000',
  },
  [StaticProfiles.SOCIAL]: {
    [Prop.FACEBOOK]: '#3B5998',
    [Prop.EVENTBRITE]: '#F6682F',
  },
  [StaticProfiles.ALERTS]: {
    [Prop.ACTIVE]: '#2176b8',
    [Prop.SUCCESS]: '#73c053',
    [Prop.INFO]: '#0b24fb',
    [Prop.WARNING]: '#F5D03B',
    [Prop.DANGER]: '#FE4A49',
    [Prop.EXPECTED]: '#47cccd',
    [Prop.ON_HOLD]: '#ff9933',
    [Prop.ALERT_WARNING_BG]: '#F5D03B',
    [Prop.ALERT_WARNING_CONTENT]: '#000000',
    [Prop.ALERT_DANGER_BG]: '#FE4A49',
    [Prop.ALERT_DANGER_CONTENT]: '#FFFFFF',
  },
  [StaticProfiles.TV]: {
    [Prop.BACKGROUND]: '#FFFFFF',
    [Prop.HEADER]: '#3F3F3F',
    [Prop.CONTENT]: '#3F3F3F',
    [Prop.BORDER]: '#3F3F3F',
    [Prop.ICON]: '#009bd1',
    [Prop.LINK]: '#009bd1',
    [Prop.LINK_HOVER]: '#009bd1',
    [Prop.ODD_EVEN_OFFSET]: '#E5EDED',
    [Prop.SIDE_NAV_ITEM_BG]: '#009bd1',
    [Prop.SIDE_NAV_ITEM_TXT]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_ICON]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_BG_ACTIVE]: '#3F3F3F',
    [Prop.SIDE_NAV_ITEM_TXT_ACTIVE]: '#FFFFFF',
    [Prop.SIDE_NAV_ITEM_ICON_ACTIVE]: '#FFFFFF',
    [Prop.TOP_NAV_ITEM_TXT]: '#FFFFFF',
  },
};
